import type { HydraContext } from "../hydra.interface";
import type { NotificationChannelEnum } from "../NotificationRule/notificationRule.interface";
import type { NotificationSubscriptionHydraItem } from "../NotificationSubscription/notificationSubscription.interface";

export enum NotificationChannelStatusEnum {
  PRESET_ALL = "preset_all",
  PRESET_IMPORTANT = "preset_important",
  PRESET_MENTION = "preset_mention",
  CUSTOM = "custom",
  DISABLED = "disabled",
}

export enum QuietHoursStrategyEnum {
  OFF = "off",
  DROP = "drop",
  INBOX_ONLY = "inbox_only",
  SUMMARY = "summary",
}

export enum QuietHoursOverrideModeEnum {
  FULLY_QUIET = "fully_quiet",
}

export interface QuietHoursWindowHydraItem extends HydraContext {
  "@type": "QuietHoursWindow"
  "channelSetting": string
  "recurrenceRule": string
  "startTime": string
  "endTime": string
  "enabled": boolean
  "createdAt": string
  "updatedAt"?: string | null
}

export interface QuietHoursDateOverrideHydraItem extends HydraContext {
  "@type": "QuietHoursDateOverride"
  "channelSetting": string
  "date": string
  "dateRangeEnd"?: string | null
  "mode": QuietHoursOverrideModeEnum
  "note"?: string | null
  "createdAt": string
  "updatedAt"?: string | null
}

export interface NotificationChannelSettingHydraItem extends HydraContext {
  "@type": "NotificationChannelSetting"
  "notificationSetting": string
  "channel": NotificationChannelEnum
  "status": NotificationChannelStatusEnum
  "sound": boolean
  "silencedUntil": string | null
  "quietHoursStrategy": QuietHoursStrategyEnum
  "quietHoursAllowImportant": boolean
  "subscriptions": NotificationSubscriptionHydraItem[]
  "quietHoursWindows": QuietHoursWindowHydraItem[]
  "createdAt": string
  "updatedAt"?: string | null
}

export interface NotificationChannelSettingHydraCollectionItem extends HydraContext {
  "@type": "NotificationChannelSetting"
  "notificationSetting": string
  "channel": NotificationChannelEnum
  "status": NotificationChannelStatusEnum
  "sound": boolean
  "silencedUntil": string | null
  "quietHoursStrategy": QuietHoursStrategyEnum
  "quietHoursAllowImportant": boolean
  "createdAt": string
  "updatedAt"?: string | null
}
